import React from 'react';

export function Croatia(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="#FF0000"/>
      <path d="M0 114H513V228H0V114Z" fill="white"/>
      <path d="M0 228H513V342H0V228Z" fill="#0093DD"/>
      <rect x="196" y="96" width="120" height="120" fill="white" stroke="#FF0000" strokeWidth="4"/>
      <rect x="196" y="96" width="40" height="40" fill="#FF0000"/>
      <rect x="236" y="96" width="40" height="40" fill="white"/>
      <rect x="276" y="96" width="40" height="40" fill="#FF0000"/>
      <rect x="196" y="136" width="40" height="40" fill="white"/>
      <rect x="236" y="136" width="40" height="40" fill="#FF0000"/>
      <rect x="276" y="136" width="40" height="40" fill="white"/>
      <rect x="196" y="176" width="40" height="40" fill="#FF0000"/>
      <rect x="236" y="176" width="40" height="40" fill="white"/>
      <rect x="276" y="176" width="40" height="40" fill="#FF0000"/>
    </svg>
  );
}
